import React from "react";
import { Helmet } from "react-helmet";

import productImage from "../assets/product-image.jpg";
import atorloycv10 from "../assets/product_images/atorloycv10.jpg";
import atorloycv20 from "../assets/product_images/atorloycv20.jpg";
import benleocs from "../assets/product_images/benleocs.jpg";
import benleod3 from "../assets/product_images/benleod3.jpg";
import benleoforte from "../assets/product_images/benleoforte.jpg";
import glimileom1 from "../assets/product_images/glimileom1.jpg";
import glimileom2 from "../assets/product_images/glimileom2.jpg";
import leogabant400 from "../assets/product_images/leogabant400.jpg";
import loytel40 from "../assets/product_images/loytel40.jpg";
import rabileod from "../assets/product_images/rabileod.jpg";
import sitaloym from "../assets/product_images/sitaloym.jpg";
import staleo10 from "../assets/product_images/staleo10.jpg";
import staleo20 from "../assets/product_images/staleo20.jpg";
import staleocv10 from "../assets/product_images/staleocv10.jpg";
import staleocv20 from "../assets/product_images/staleocv20.jpg";
import staleogold10 from "../assets/product_images/staleogold10.jpg";
import staleogold20 from "../assets/product_images/staleogold20.jpg";

function Products() {
  const categories = [
    "Tablets & Capsules",
    "Injectables",
    "IV Fluids",
    "Critical Care Medicines",
    "Antibiotics",
    "Cardiac Range"
  ];

  return (
    <div>
      <Helmet>
        <title>Pharmaceutical Products | Leocord Healthcare Supply</title>

        <meta
          name="description"
          content="Explore Leocord pharmaceutical products supplied to hospitals and healthcare institutions with reliable quality and regulatory compliance."
        />

        <meta
          name="keywords"
          content="pharmaceutical products supplier, hospital medicines supplier, healthcare pharma products"
        />

        <link rel="canonical" href="https://leocordhealthcare.com/products" />
      </Helmet>
      <section className="products-header">
        <div className="container">
          <h1>Leocord Healthcare Products</h1>
          <p className="lead mt-3">
            Our diverse portfolio includes tablets, capsules, injectables, IV fluids, and critical care medicines manufactured under strict regulatory and quality standards.
          </p>
        </div>
      </section>
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-md-6">
              <h2 className="mb-3">Quality Driven Pharmaceutical Solutions</h2>
              <p className="text-muted">Leocord provides a comprehensive range of pharmaceutical products designed to support hospitals, clinics, and healthcare institutions. Our product portfolio includes high-quality medicines sourced from trusted manufacturers that comply with industry regulations and healthcare standards.</p>
              <p className="text-muted">We focus on delivering reliable pharmaceutical solutions that help healthcare providers maintain consistent treatment availability and improve patient care outcomes. Each product undergoes strict quality checks to ensure safety, effectiveness, and compliance with regulatory guidelines.</p>
              <p className="text-muted">Our pharmaceutical supply network enables efficient distribution and timely delivery, helping healthcare institutions access the medicines they need without disruption.</p>
            </div>

            <div className="col-md-6 text-center">
              <img
                src={productImage}
                alt="Leocord Healthcare Products"
                className="img-fluid rounded shadow"
              />
            </div>

          </div>
        </div>
      </section>
      <section className="py-5">
          <div className="container">            
            <h3 className="mb-4">Leocord Healthcare Products</h3>
            <div class="row">
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={atorloycv10} className="img-fluid" alt="Atorloy CV 10" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={atorloycv20} className="img-fluid" alt="Atorloy CV 20" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={benleocs} className="img-fluid" alt="Benleo CS" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={benleod3} className="img-fluid" alt="Benleo D3 60K" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={benleoforte} className="img-fluid" alt="Benleo Forte" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={glimileom1} className="img-fluid" alt="Glimileo M1" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={glimileom2} className="img-fluid" alt="Glimileo M2" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={leogabant400} className="img-fluid" alt="Leogaba NT 400" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={loytel40} className="img-fluid" alt="Loytel 40" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={rabileod} className="img-fluid" alt="Rabileo D" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={sitaloym} className="img-fluid" alt="Sitaloy M" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={staleo10} className="img-fluid" alt="Staleo 10" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={staleo20} className="img-fluid" alt="Staleo 20" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={staleocv10} className="img-fluid" alt="Staleo CV 10" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={staleocv20} className="img-fluid" alt="Staleo CV 20" /></div></div>
              <div class="col-md-3 col-4"><div className="border mb-4"><img src={staleogold10} className="img-fluid" alt="Staleo Gold 10" /></div></div>
              <div class="col-md-3 col-4"><div className="border"><img src={staleogold20} className="img-fluid" alt="Staleo Gold 20" /></div></div>
            </div>
          </div>
      </section>
      <section className="py-5 d-none">
        <div className="container">
          <div class="row mb-4">
            <h3 className="mb-4">Leocord Healthcare Products</h3>
            <div className="col-md-3 col-12">
              <ul>
                <li>Statleo 10</li>
                <li>Statleo 20</li>
                <li>Statleo CV10</li>
                <li>Statleo Gold 10</li>
                <li>Statleo Gold 20</li>
              </ul>
            </div>
            <div className="col-md-3 col-12">
              <ul>
                <li>Loytel 40</li>
                <li>Loytel H</li>
                <li>Loytel C</li>
                <li>Loytel CM</li>
                <li>Atorloy 20</li>
                <li>Atorloy 40</li>
              </ul>
            </div>
            <div className="col-md-3 col-12">
              <ul>
                <li>Atorloy CV10</li>
                <li>Sitaloy D/DM</li>
                <li>Sitaloy M</li>
                <li>Glimileo M1</li>
                <li>Glimileo M2</li>
              </ul>
            </div>
            <div className="col-md-3 col-12">
              <ul>
                <li>Leogaba NT</li>
                <li>Rabileo</li>
                <li>Benleo</li>
                <li>Benleo D3 60K</li>
                <li>Benleo Q10</li>
              </ul>
            </div>
          </div>
          <div className="row g-4">
            {categories.map((item, index) => (
              <div className="col-md-4" key={index}>
                <div className="card premium-card h-100 p-4">
                  <h5>{item}</h5>
                  <p className="text-muted">
                    Manufactured under strict quality and regulatory guidelines.
                  </p>
                  <button className="btn btn-outline-primary btn-sm">
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
      <section className="py-5 bg-light">
        <div className="container text-center">
          <h2 className="mb-4">Therapeutic Segments</h2>
          <p className="text-muted mb-5">
            Our product portfolio spans across multiple therapeutic areas supporting
            hospitals and healthcare professionals.
          </p>

          <div className="row g-4">
            <div className="col-md-3">
              <div className="therapeutic-box">
                <h5>Cardiology</h5>
              </div>
            </div>

            <div className="col-md-3">
              <div className="therapeutic-box">
                <h5>Critical Care</h5>
              </div>
            </div>

            <div className="col-md-3">
              <div className="therapeutic-box">
                <h5>Anti-Infectives</h5>
              </div>
            </div>

            <div className="col-md-3">
              <div className="therapeutic-box">
                <h5>General Medicine</h5>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Products;